import React from 'react';
import {
  Icon, Menu, Popup,
} from 'semantic-ui-react';
import { validationClasses } from '@/utils/errors';
import CohortQueryTools from '../containers/CohortQueryTools';
import CohortQueryStatusPopup from './CohortQueryStatusPopup';
import { isValidQueryStatus } from '../../visualisations/helper';

const CohortQueryMenuItem = ({
  uuid,
  name,
  canEdit,
  code,
  category,
  validationErrors,
  saveErrors,
  active,
  status,
  updatePanels,
}) => {
  const errors = saveErrors.concat(validationErrors);
  const validationError = errors.find((e) => e?.context.queryUUID === uuid);
  const validQuery = isValidQueryStatus(status);

  return (
    <Menu.Item
      key={`cohort_query_pane_${uuid}`}
      className={validationClasses(validationError || !validQuery, 'aridhia-cohort-query-tab')}
      active={active}
      onClick={() => updatePanels(code, category, uuid)}
    >
      {!validQuery && (
      <Popup
        trigger={<Icon name="info circle" />}
      >
        <CohortQueryStatusPopup status={status} />
      </Popup>
      )}
      {name}
      {canEdit && (
        <CohortQueryTools
          iconSize="large"
          category={category}
          code={code}
          queryUUID={uuid}
        />
      )}
    </Menu.Item>
  );
};

export default CohortQueryMenuItem;
